import { render, staticRenderFns } from "./formSharedFile.vue?vue&type=template&id=29cb3aee&"
import script from "./formSharedFile.vue?vue&type=script&lang=js&"
export * from "./formSharedFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports